var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFile = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 3.5C2.39431 3.5 0.973684 4.94367 0.973684 6.70259V15.2974C0.973684 17.0563 2.39431 18.5 4.16833 18.5H32.8317C34.6057 18.5 36.0263 17.0563 36.0263 15.2974V6.70259C36.0263 4.94368 34.6057 3.5 32.8317 3.5H4.16833ZM0 6.70259C0 4.37174 1.87589 2.5 4.16833 2.5H32.8317C35.1241 2.5 37 4.37174 37 6.70259V15.2974C37 17.6283 35.1241 19.5 32.8317 19.5H4.16833C1.87589 19.5 0 17.6283 0 15.2974V6.70259Z",
    fill: "#99AABD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9352 8.7495V7.5L11 7.51079V14H12.4589V11.3758H14.3713V10.1824H12.4589V8.7495H14.9352Z",
    fill: "#99AABD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2784 7.5V13.9892H16.8196V7.5H18.2784Z",
    fill: "#99AABD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0405 12.7872H21.0859L21.0899 7.5H19.629V13.9892H23.0405V12.7872Z",
    fill: "#99AABD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3001 10.1069V8.74735H27.5998V7.5H23.8432V13.9892H27.5998V12.7311H25.3001V11.2895H27.3389V10.1069H25.3001Z",
    fill: "#99AABD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file.4b109a84fb20eeeebcb221926e764ca9.svg";